import { useState, useEffect } from 'react'
import { getSubscriptions } from '../api/subscriptions'

/**
 * Fetch a list of subscriptions.
 *
 * @param {Function} fetcher - Optional async function that returns a list.
 *                               Defaults to getSubscriptions().
 */
export function useSubscriptions(fetcher = getSubscriptions) {
  const [subscriptions, setSubscriptions] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)

    fetcher()
      .then((data) => {
        if (!cancelled) setSubscriptions(data)
      })
      .catch((err) => {
        if (!cancelled) setError(err.message)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [fetcher])

  return { subscriptions, loading, error }
}
